import React from 'react';
import FilesUploaded from './FilesUploaded';
const VideoUploaded = (props) => {
    return React.createElement(FilesUploaded, Object.assign({}, props, { rowDataQaAnchor: "post-creator-uploaded-video" }));
};
export default VideoUploaded;
//# sourceMappingURL=VideosUploaded.js.map